import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Menu, X, LogOut, LayoutDashboard, ShieldCheck } from 'lucide-react';

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const handleLogout = async () => { await logout(); navigate('/'); };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-[#050505]/80 backdrop-blur-xl border-b border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2.5" data-testid="logo-link">
            <img src="/ayronn-logo.png" alt="AYRONN Funding" className="h-[70px] sm:h-[85px] md:h-[102px] w-auto" />
          </Link>

          <div className="hidden md:flex items-center space-x-6">
            {(!user || user === false) && <Link to="/" className="text-zinc-400 hover:text-white transition-colors text-sm" data-testid="nav-home">Home</Link>}
            <Link to="/pricing" className="text-zinc-400 hover:text-white transition-colors text-sm" data-testid="nav-pricing">Pricing</Link>
            {user && user.role === 'admin' && user.email === 'ayushshahu91@gmail.com' && (
              <Link to="/admin" className="text-zinc-400 hover:text-white transition-colors text-sm flex items-center gap-1.5" data-testid="nav-admin"><ShieldCheck className="w-3.5 h-3.5" /> Admin</Link>
            )}
            {user && user !== false ? (
              <>
                <Link to="/dashboard" className="text-zinc-400 hover:text-white transition-colors text-sm flex items-center gap-1.5" data-testid="nav-dashboard"><LayoutDashboard className="w-3.5 h-3.5" /> Dashboard</Link>
                <button onClick={handleLogout} className="flex items-center gap-2 px-4 py-2 bg-transparent border border-white/20 text-white hover:bg-white/5 hover:border-brand-primary transition-all rounded-lg text-sm" data-testid="logout-btn"><LogOut className="w-3.5 h-3.5" /> Logout</button>
              </>
            ) : (
              <Link to="/auth" className="px-6 py-2 bg-brand-primary text-black font-semibold rounded-lg glow-primary hover:glow-primary-strong transition-all text-sm" data-testid="get-started-btn">Get Started</Link>
            )}
          </div>

          <button onClick={() => setIsOpen(!isOpen)} className="md:hidden text-white" data-testid="mobile-menu-toggle">
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {isOpen && (
        <div className="md:hidden bg-[#0F0F12] border-t border-white/5" data-testid="mobile-menu">
          <div className="px-6 py-4 space-y-4">
            {(!user || user === false) && <Link to="/" className="block text-zinc-400 hover:text-white" onClick={() => setIsOpen(false)}>Home</Link>}
            <Link to="/pricing" className="block text-zinc-400 hover:text-white" onClick={() => setIsOpen(false)}>Pricing</Link>
            {user && user.role === 'admin' && user.email === 'ayushshahu91@gmail.com' && (
              <Link to="/admin" className="block text-zinc-400 hover:text-white" onClick={() => setIsOpen(false)}>Admin</Link>
            )}
            {user && user !== false ? (
              <>
                <Link to="/dashboard" className="block text-zinc-400 hover:text-white" onClick={() => setIsOpen(false)}>Dashboard</Link>
                <button onClick={() => { handleLogout(); setIsOpen(false); }} className="w-full text-left text-zinc-400 hover:text-white">Logout</button>
              </>
            ) : (
              <Link to="/auth" className="block px-6 py-2 bg-brand-primary text-black font-semibold rounded-lg text-center" onClick={() => setIsOpen(false)}>Get Started</Link>
            )}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
